import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CustomButtonComponent } from './custom-button.component';




@NgModule({
  declarations: [
    CustomButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[CustomButtonComponent]
})
export class CustomButtonModule { }
